var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"custom-line-placeholder",on:{"click":_vm.onAddCustomLine}},[_c('span',{staticClass:"custom-line-placeholder__line"}),_c('AddIconSvg',{staticClass:"custom-line-placeholder__icon"}),_c('span',{staticClass:"custom-line-placeholder__line"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }